import React from "react";
import { Link } from "react-router-dom";
import "../../common/bg.css";
import "./c.css";
import WebsiteName from "../../common/WebsiteName/WebsiteName";
import Navbar from "../../common/Navbar/NavBar";
import Location from "../../common/Location/Location";
import Footer from "../../common/Footer/Footer";
export default function C_info() {
  return (
    <>
      <section className="bgImageCommon">
        <WebsiteName />
        <Navbar />
        <Location title="React Native" />
        <section>
          <div className="cBody">
            <div id="cardDIV">
              <h1 className="text-dark" id="laguage_Title">
                React Native
              </h1>
              <p className="text-secondary" id="Language_Para">
                React Native is an open-source framework for building
                cross-platform applications (apps) using React and the
                platform's native capabilities. In this course, you will move
                from the basics of React to a more advanced implementation using
                React Native.
                <br />
                React Native allows you to build apps faster. Instead of
                recompiling, you can reload an app instantly. By making use of
                its Hot Reloading feature, you can even run new features while
                maintaining your application state.
                <br />
                React Native is an excellent choice for mobile app development
                due to its cross-platform functionality, faster performance, and
                simplicity. It allows developers to build high-quality mobile
                apps using a single codebase, reducing development costs and
                time.
                <br />
              </p>
              <Link
                name=""
                id=""
                class="btn btn-danger"
                to="/Courses"
                role="button">
                {"<< "}back
              </Link>
            </div>
          </div>
        </section>
        <Footer />
      </section>
    </>
  );
}
